import type React from 'react'
import { Card, Box } from '@truepill/react-capsule'
import styled from 'styled-components'
import { contrastBackgroundColor } from 'styles/styleVariables'

export type TPOSCardProps = {
  header: string | React.ReactElement
  children: React.ReactElement
}

export const TPOSCard = ({ header, children }: TPOSCardProps): JSX.Element => {
  return (
    <Card shadow="sm" width="auto" padding="none" css={{ borderRadius: '0.75rem' }}>
      <CardHeader>{header}</CardHeader>

      <Box css={{ padding: '0rem 1.5rem 0.75rem' }}>{children}</Box>
    </Card>
  )
}

const CardHeader = styled(Box)`
  background-color: ${contrastBackgroundColor};
  border-radius: 0.75rem 0.75rem 0rem 0rem;
  font-family: var(--cap-fonts-base);
  font-weight: bold;
  padding: 0.75rem 1.5rem;
`
